import "./Home.css";
import Collections from "./collections/Collections";
import Features from "./Feature/Features";
import Shapingd from "./shaping/ Shapingd";
import Footer from "../Footer/Footer";
import ExploreCollection from "./exploreCollection/ExploreCollection";
import Navbar from "./Navbar/Navbar";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

export default function Home() {
	const [data, setData] = useState([]);
	const [years, setYears] = useState([]);
	const [error, setError] = useState(null);

	// Dummy data as fallback
	useEffect(() => {
		const fetchData = async () => {
			try {
				
				setError(null);

				const apiUrl = `https://admin.monsinidress.com/api/products/brand`;
				console.log("Fetching from:", apiUrl);

				const response = await fetch(apiUrl, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ brand: "Azure" }),
				});

				if (!response.ok) {
					throw new Error(`API response not ok: ${response.status}`);
				}
				console.log(response);

				const apiData = await response.json();

				console.log(apiData.data.products);
				if (apiData.data && apiData.data.products.length > 0) {
					setData(apiData.data.products);
					setYears(apiData.data.years);
					console.log("Data fetched from API:", apiData.length, "items");
				} else {
					throw new Error("No data received from API");
				}
			} catch (apiError) {
				console.warn("API fetch failed, using dummy data:", apiError.message);
				setError(apiError.message);
			} 
		};

		fetchData();
	}, []);

	const latestYear = [...years].sort((a, b) => b - a);

	// You will need to make sure the Icon component is imported:
	// import { Icon } from '@iconify/react';

	
	if (data.length < 0 && error) {
		return (
			<div className="flex justify-center items-center min-h-screen">
				<div className="text-xl">
					Plz wait here some issue in the netwok {error}
				</div>
			</div>
		);
	}

	console.log("data :", data);
	console.log("lastesd Years : ...", latestYear);
	return (
		<div className="relative overflow-hidden">
			<Navbar />
			<ExploreCollection latestYear={latestYear[0]} />
			<Collections data={data} latestYear={latestYear[0]} />
			<TypeDress title={"Shine Bright, Dance Bold."} data={data} />
			<TypeDress title={"Forever Starts with You."} data={data} />
			<TypeDress title={"Grace, Glamour, Timeless Beauty."} data={data} />
			<Features data={data} />
			<Shapingd />
			<Footer />
		</div>
	);
}

function TypeDress({ title, data = [] }) {
	const scrollRef = useRef(null);
	const randomdata = (data) => {
		// 1. Get all unique years from the data
		const allYears = Array.isArray(data)
			? [...new Set(data.map((item) => item.year))].sort((a, b) => b - a) // Sort descending (Latest year first)
			: [];

		let featuredData = [];
		let count = 0;
		const limit = 6;

		// 2. Iterate through years, starting with the latest
		for (const year of allYears) {
			if (count >= limit) break; // Stop if we've already collected 6 items

			// Filter for products from the current year that are marked as viewInfront: true
			const yearFeatured = data.filter(
				(item) => item.viewInfront === true && item.year === year
			);

			// 3. Randomize and collect the remaining slots
			if (yearFeatured.length > 0) {
				// Randomize the items for the current year
				const randomizedYearData = yearFeatured.sort(() => 0.5 - Math.random());

				// Calculate how many more items we need to reach the limit
				const needed = limit - count;

				// Take up to 'needed' items from the randomized list
				const itemsToAdd = randomizedYearData.slice(0, needed);

				// Add the new items to the final array
				featuredData = featuredData.concat(itemsToAdd);

				// Update the count
				count = featuredData.length;
			}
		}

		// 4. If less than 6 items were found even after checking all years,
		// you can optionally fill the remaining slots with non-featured items
		// (but the current logic stops here, which usually is what's desired for "featured").

		return featuredData;
	};

	// Example usage:
	const randomdataResult = randomdata(data);

	const scroll = (direction) => {
		const container = scrollRef.current;
		if (!container) return;

		const firstItem = container.firstElementChild;
		if (!firstItem) return;

		const nextItem = firstItem.nextElementSibling;
		let scrollAmount = 0;

		if (nextItem) {
			scrollAmount = nextItem.offsetLeft - firstItem.offsetLeft;
		} else {
			scrollAmount = firstItem.offsetWidth + 16;
		}

		if (direction === "left") {
			container.scrollLeft -= scrollAmount;
		} else {
			container.scrollLeft += scrollAmount;
		}
	};

	return (
		<div className="relative overflow-hidden mb-20">
			{/* Title */}
			<div className="text-center font-lora font-semibold text-3xl md:text-5xl mb-20">
				<h3>{title}</h3>
			</div>

			{/* Left Arrow */}
			<button
				onClick={() => scroll("left")}
				className="absolute left-4 top-[60%] -translate-y-1/2 bg-[#1f4c94] shadow-md p-2 rounded-full z-10 hover:bg-[#1f4c94] transition">
				<Icon icon="mdi:chevron-left" className="text-3xl text-white" />
			</button>

			{/* Scrollable Images */}
			<div
				ref={scrollRef}
				className="flex gap-3 overflow-x-auto px-4 scroll-smooth scrollbar-hide no-scrollbar">
				{randomdataResult.map((item, index) => (
					<Link
						to={`/product/id/${item.style}`}
						state={{
							product: item,
						}}
						key={index}
						className="relative w-[350px] h-[400px] flex-shrink-0 group overflow-hidden">
						<img
							src={`https://admin.monsinidress.com/${item.images?.[0]}`}
							alt={item.style}
							className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
						/>
						<div className="flex justify-center items-center absolute bg-[#1f4c94] bottom-3 font-lora right-3 text-white text-md px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300">
							{item.style}
							<span>
								<Icon
									icon="flowbite:arrow-right-outline"
									width="1.6rem"
									height="1.6rem"
									style={{ color: "white" }}
									className="ms-5 lg:block md:block hidden"
								/>
							</span>
						</div>
					</Link>
				))}
			</div>

			{/* Right Arrow */}
			<button
				onClick={() => scroll("right")}
				className="absolute right-4 top-[60%] -translate-y-1/2 bg-[#1f4c94] shadow-md p-2 rounded-full z-10 hover:bg-[#1f4c94] transition">
				<Icon icon="mdi:chevron-right" className="text-3xl text-white" />
			</button>
		</div>
	);
}
